import { render, staticRenderFns } from "./CampaignLandingComponent.vue?vue&type=template&id=05278c80&scoped=true"
import script from "./CampaignLandingComponent.vue?vue&type=script&lang=js"
export * from "./CampaignLandingComponent.vue?vue&type=script&lang=js"
import style0 from "./CampaignLandingComponent.vue?vue&type=style&index=0&id=05278c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05278c80",
  null
  
)

export default component.exports